import { render, staticRenderFns } from "./XmVideo.vue?vue&type=template&id=dd6f2e7c&scoped=true"
import script from "./XmVideo.vue?vue&type=script&lang=js"
export * from "./XmVideo.vue?vue&type=script&lang=js"
import style0 from "./XmVideo.vue?vue&type=style&index=0&id=dd6f2e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f2e7c",
  null
  
)

export default component.exports